import { render, staticRenderFns } from "./FKomoditiTypeTable.vue?vue&type=template&id=80047d00&scoped=true"
import script from "./FKomoditiTypeTable.vue?vue&type=script&lang=js"
export * from "./FKomoditiTypeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80047d00",
  null
  
)

export default component.exports